import { render } from "./form-signature-pad.vue?vue&type=template&id=595239d8"
import script from "./form-signature-pad.vue?vue&type=script&lang=js"
export * from "./form-signature-pad.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__